<style scoped>
.capture672 {
  background: url("https://capture672-public.s3-eu-west-1.amazonaws.com/background-2.jpg");
  background-repeat: no-repeat;
  background-size: cover;
}

.capture672 .bg-image {
  height: 100%;
}

.capture672 .gradient-mask {
  /**
  background: -webkit-linear-gradient(rgba(0, 47, 75, 0.8) 0%, rgba(220, 66, 37, 0.8) 100%);
  background: -o-linear-gradient(rgba(0, 47, 75, 0.8) 0%, rgba(220, 66, 37, 0.8) 100%);
  background: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 47, 75, 0.8)), to(rgba(220, 66, 37, 0.8)));
  background: linear-gradient(rgba(0, 47, 75, 0.8) 0%, rgba(220, 66, 37, 0.8) 100%);
  **/
  background: -webkit-linear-gradient(
    rgba(54, 194, 117, 0.8) 0%,
    rgba(220, 66, 37, 0.8) 100%
  );
  background: -o-linear-gradient(
    rgba(54, 194, 117, 0.8) 0%,
    rgba(220, 66, 37, 0.8) 100%
  );
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(rgba(0, 47, 75, 0.8)),
    to(rgba(220, 66, 37, 0.8))
  );
  background: linear-gradient(
    rgba(54, 194, 117, 0.8) 0%,
    rgba(220, 66, 37, 0.8) 100%
  );
  /* Chrome10+,Safari5.1+ */
  /* Opera 11.10+ */
  /* IE10+ */
  /* W3C */
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#002f4b', endColorstr='#00000000', GradientType=0);
}

.capture672 .theme--light.v-sheet {
  background-color: transparent;
  border-color: #fff;
  color: #fff;
}
.capture672 input:-internal-autofill-selected {
  background-color: transparent !important;
  background-image: none !important;
  color: #fff !important;
}

.capture672 .theme--light.v-label {
  background-color: transparent;
  color: #fff !important;
}
.capture672 .v-label.theme--light {
  color: #fff;
}

.capture672 .theme--light .v-icon {
  color: #fff;
}
.capture672 .theme--light .v-label {
  color: #fff;
}
.capture672 .v-text-field__slot input {
  color: red;
}
.capture672 .button-green-gradient {
  background: #00d301;
  background: -webkit-linear-gradient(-196deg, #00d301, #36c275 50%, #00a562);
  background: -webkit-linear-gradient(164deg, #00d301, #36c275 50%, #00a562);
  background: linear-gradient(286deg, #00d301, #36c275 50%, #00a562);
}
</style>
<style>
/* .capture672 .theme--light.v-input:not(.v-input--is-disabled) input {
  color: #fff;
}
.capture672 .theme--light.v-label {
  color: #fff;
}
.capture672 input:-webkit-autofill,
.capture672 input:-webkit-autofill:hover,
.capture672 input:-webkit-autofill:focus,
.capture672 input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 80px rgba(102, 175, 233, 0.1) inset !important;
  background-color: rgba(102, 175, 233, 0.1) !important;
  background-clip: content-box !important;
}
.capture672 input:-webkit-autofill,
.capture672 input:-webkit-autofill:hover,
.capture672 input:-webkit-autofill:focus,
.capture672 input:-webkit-autofill:active {
  -webkit-animation: autofill 0s forwards;
  animation: autofill 0s forwards;
}
.capture672 input:-webkit-autofill,
capture672 input:-webkit-autofill:focus {
  box-shadow: 0 0 0 1000px white inset;
  -webkit-text-fill-color: #fff;
}
@keyframes autofill {
  100% {
    background: transparent;
    color: inherit;
  }
}

@-webkit-keyframes autofill {
  100% {
    background: transparent;
    color: inherit;
  }
} */

/* input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus textarea:-webkit-autofill,
textarea:-webkit-autofill:hover textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0px 1000px #ffffff inset !important;
} */
</style>
<style>
.capture672 input:-webkit-autofill,
.capture672 input:-webkit-autofill:hover,
.capture672 input:-webkit-autofill:focus,
.capture672 input:-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s;
}
.capture672 input:-webkit-autofill
{
 -webkit-text-fill-color: white !important;
}
</style>
<template>
  <v-app id="signup" :class="signupClass">
    <div style="position: absolute; left: 0; width: 100%; height: 100%">
      <!--
      <vue-particles
      color="#dedede"
      :particleOpacity="0.7"
      :particlesNumber="80"
      shapeType="circle"
      :particleSize="4"
      linesColor="#dedede"
      :linesWidth="1"
      :lineLinked="true"
      :lineOpacity="0.4"
      :linesDistance="150"
      :moveSpeed="3"
      :hoverEffect="true"
      hoverMode="grab"
      :clickEffect="true"
      clickMode="push"
    >
    </vue-particles>
  -->
    </div>
    <v-content class="gradient-mask">
      <v-container fluid fill-height>
        <v-layout align-center justify-center row wrap>
          <v-flex
            xs12
            sm8
            md4
            align-center
            justify-center
            style="text-align: center"
          >
            <a href="https://capture672.com" v-if="signupClass == 'capture672'">
              <img
                alt="Capture672 Logo"
                width="250"
                src="https://capture672-public.s3-eu-west-1.amazonaws.com/capture672-logo.png"
              />
            </a>
            <div v-else>
            <a href="https://taybull.com" v-if="options && options.image && options.image.url">
              <img
                alt="WFS Logo"
                :src="options.image.url"
                :style="options.image.style"
              />
            </a>
            <a href="https://taybull.com" v-else>
              <img
                v-if="subDomain == 'wfs'"
                alt="WFS Logo"
                src="https://taybull.s3.eu-west-2.amazonaws.com/wfs.png"
              />
              <img v-else alt="Logo" width="350" :src="imageUrl" />
            </a>
            </div>

            <br />
            <p v-if="signupClass == 'capture672'" style="color: #fff">
              <b>Simple Air Waybill Processing </b>
            </p>
            <v-alert :value="true" type="error" v-if="error">
              We couldn’t find an account matching the username and password you
              entered. Please check your username and password and try again.
            </v-alert>
            <form id="sign-in-form" @submit.prevent="submit()">
              <v-card class="elevation-12">
                <v-card-text>
                  <v-text-field
                    prepend-icon="email"
                    v-model="username"
                    name="username"
                    v-validate="'required'"
                    :error-messages="errors.collect('username')"
                    label="Username"
                    ref="username"
                  ></v-text-field>
                  <v-text-field
                    id="password"
                    v-model="password"
                    name="password"
                    :error-messages="errors.collect('password')"
                    prepend-icon="lock"
                    label="Password"
                    type="password"
                    v-validate="'required'"
                    ref="password"
                  ></v-text-field>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    type="submit"
                    form="sign-in-form"
                    class="button-green-gradient"
                    >Sign In</v-btn
                  >
                </v-card-actions>
              </v-card>
            </form>
            <p class="text-md-center">
              <br />
              <br />
               <img
                v-if="isSingleSignOnActive"
                @click="singleSignOn()"
                style="cursor: pointer"
                alt="Login With Microsoft"
                src="ms-symbollockup_signin_light.png"
              />
              <!--
              <span v-if="subDomain != 'wfs'"> Not a member? <router-link :to="{name: 'signup'}"> Sign up now </router-link></span>
            -->
              <br />
              <br />
              <br />
              <br />
            </p>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const host = window.location.host;
let hostname = window.location.hostname;
// hostname = "admin.dataview365.com";
let parts = host.split(".");
const subDomain = parts.length && parts[0] ? parts[0].toLowerCase() : "";
const { mapActions, mapMutations } =
  createNamespacedHelpers("users");
import { clearStorage } from "@/services/localstorage.service";
import { isSingleSignOnActive, get } from "@/services/client.service";

export default {
  data: () => ({
    imageUrl: "../assets/logo-white-bg.svg",
    signupClass: "",
    hostname: hostname,
    subDomain: subDomain,
    isSingleSignOnActive: isSingleSignOnActive(),
    drawer: null,
    error: false,
    username: "",
    password: "",
  }),
  props: {
    source: String,
    options: Object,
  },
  methods: {
    ...mapActions(["aSignIn"]),
    ...mapMutations(["mPurgeAuth"]),
    singleSignOn() {
      try {
        localStorage.removeItem('azure_id_token');
        localStorage.removeItem('azure_expires_at');
        localStorage.removeItem('azure_profile');
      } catch(error) {
        //
      }
      this.mPurgeAuth();
      clearStorage();

      let r = this.$router.resolve({
        name: 'single-signon'
      });
      // alert(r.href);
      window.location.assign(r.href)
      // this.$router.go(r.href);
    },
    submit() {
      const payload = {
        username: this.username,
        password: this.password,
      };
      let signIn = this.signIn;
      this.$validator
        .validateAll()
        .then(function (response) {
          if (response === true) {
            signIn(payload);
          }
        })
        .catch(function (e) {});
    },
    signIn(payload) {
      let progress = this.$Progress;
      let router = this.$router;
      const signIn = this.aSignIn;
      let $this = this;
      progress.start();
      signIn(payload)
        .then(function (response) {
          progress.finish();
          router.push({ name: "projects-home" });
        })
        .catch(function (e) {
          progress.finish();
          $this.error = true;
        });
    },
  },
  mounted() {
    
    this.mPurgeAuth();
    clearStorage();

    this.imageUrl = "../assets/logo-white-bg.svg";
    
    this.signupClass = get('signupClass');
    if (this.hostname == "admin.legalworkflow365.com") {
      this.signupClass = "legalworkflow365";
      this.imageUrl =
        " https://legalworkflow365-public.s3.eu-west-2.amazonaws.com/legalworkflow365.png";
    } else if (this.hostname == "app-pay.taybull.com" || this.hostname == "admin-pay.taybull.com") {
      this.signupClass = "taybullpay";
      this.imageUrl =
        "https://static.wixstatic.com/media/158464_000198d5938e4b9f9ea2e5344233b811~mv2.png/v1/fill/w_162,h_162,al_c,lg_1,q_85/logo_150x150.webp";
    } else if (this.hostname == "app.dataview365.com" || this.hostname == "admin.dataview365.com") {
      this.imageUrl = "../assets/dataview365.png";  
    }

    // this.$refs.username.click();
    // console.log('this.$refs.username.$el', this.$refs.username.$el);
    // this.$validator.localize('en', this.dictionary);
  },
  beforeCreate() {},
};
</script>
